import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material';
import {UserService} from '@services/user.service';
import {DialogSharedComponent} from '@components/dialog-shared/dialog-shared.component';
import {InitInformation} from "@models/init-information.interface";
import {ShipmentService} from "@services/shipment.service";

@Component({
  selector: 'settings',
  templateUrl: './settings.component.html'
})

export class SettingsComponent implements OnInit {
  userDetail = 'detail';
  userDetails: any;
  form: FormGroup;
  userDiscountsForm: FormGroup;
  allExtraCharges = [];
  companies = [{name: 'N/A', id: null}];
  progress = false;
  userId?: number;
  // customerRules: any;
  customer: any;
  currentCompanyId:  number;
  openWindow(href) {
    window.open(href, '');
    return false;
  }
  possibleCountries: Array<{value: string; label: string}>;
  constructor(private userService: UserService,
              private _fb: FormBuilder,
              public dialog: MatDialog,
              private shipmentService: ShipmentService) { }

  ngOnInit() {
    this.userService.userId.subscribe(id => this.userId = id);
    this.userService.userDetails.subscribe(data => {
      this.userDetails = data;
      if (data) {
        this.initializeForm();
        this.customer = this.userDetails.id;
        this.currentCompanyId = this.userDetails.company_id;
      }

    });
    this.shipmentService.getInitialData()
      .subscribe((data: InitInformation) =>
        this.possibleCountries = this.shipmentService.possibleCountries);


    const params =  {page : 1,
      size: '100',
      filter: '',
      sort: '',
      order: ''};

    this.userService.getCompanies(params).subscribe((companies) => {
      for (const i in companies.data) {
        this.companies.push(companies.data[i]);
      }
    });
  }


  initializeForm() {
    this.form = this._fb.group({
      // user: this._fb.group({
      name: [this.userDetails.name, Validators.required],
      surname: [this.userDetails.surname, Validators.required],
      email: [this.userDetails.email, [Validators.required, Validators.email]],
      // company_name: [this.userDetails.company_name],
      company_name: new FormControl(this.userDetails.company_name),
      phone: [this.userDetails.phone, [this.validatePhone]],
      invoice_country_code: [this.userDetails.invoice_country_code],
      invoice_zip: [this.userDetails.invoice_zip],
      invoice_city: [this.userDetails.invoice_city],
      invoice_address: [this.userDetails.invoice_address],
      confirmed: [this.userDetails.confirmed, Validators.required],
      role: [this.userDetails.role, Validators.required],
      status: [this.userDetails.status, Validators.required],
      statusCheckbox: [this.userDetails.status === 1],
      master_id: [this.userDetails.master_id],
      // logged_at: [this.userDetails.logged_at],
      id: [this.userDetails.id],
      company_id: [this.userDetails.company_id]

      // }),
    });


  }

  changeCompany(companyId, old) {
    this.progress = true;
    if (companyId.value == null) {
      this.userService.unassignUser(this.currentCompanyId, this.userDetails.id).subscribe(() => {
        this.progress = false;
      });
    } else {
      this.userService.assignUser(companyId.value, this.userDetails.id).subscribe(() => {
        this.progress = false;
      });
    }
    this.currentCompanyId = companyId.value;

  }
  // discounts
  // toggleDetail(selector) {
  //   this.userDetail = selector;
  // }

  save() {
    this.progress = true;
    if (this.form.valid) {
      const data = {
        id: this.form.get('id').value,
        name: this.form.get('name').value,
        surname: this.form.get('surname').value,
        email: this.form.get('email').value,
        phone: this.form.get('phone').value,
        invoice_zip: this.form.get('invoice_zip').value,
        invoice_city: this.form.get('invoice_city').value,
        invoice_address: this.form.get('invoice_address').value,
        invoice_country_code: this.form.get('invoice_country_code').value,
        confirmed: this.form.get('confirmed').value,
        role: this.form.get('role').value,
        status: this.form.get('status').value,
        master_id: this.form.get('master_id').value,
        // logged_at: this.form.get('logged_at').value,

      };
      this.userService.setUser(data).subscribe(() => {
        this.progress = false;
      });
    } else {
      const dialogRef = this.dialog.open(DialogSharedComponent,
        {width: '450px', data: { errorType: 'null', header: 'service.fieldsMustBeFilled' }});
      this.progress = false;
    }
    return false;
  }

  changeConfirmedEmail({checked}) {
    const value = checked ? 1 : 0;
    this.form.get('confirmed').setValue(value);
  }

  changeStatus({checked}) {
    const value = checked ? 1 : 2;
    this.form.get('status').setValue(value);
  }

  validatePhone(control: FormControl) {
    const pattern = /^[0-9\-\+\ \(\)]+/g;
    if (control.value && !pattern.test(control.value)) {
      return {pattern: true};
    }
    return null;
  }

  validateEmail(control: FormControl) {
    const pattern = /^[a-zA-Z0-9\.\-\+'_]+@[a-zA-Z0-9]+(\-[a-zA-Z0-9]+|\.[a-zA-Z0-9]+)*\.[a-zA-Z]{2,6}$/i;
    if (!pattern.test(control.value)) {
      return { pattern: true };
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/settings/settings.component.ts